import lozad from 'lozad';

jQuery(document).ready(function ($) {
	const observer = lozad();
	observer.observe();

});
